import { ListParams, PaginatedResponse } from '../types/pagination'

import { http } from '@/app/lib/http/client'

// ─── Tipos de movimiento ──────────────────────────────────────────────────────

export type MovementType =
  | 'purchase'                      // Ingreso por compra
  | 'sale'                          // Salida por venta
  | 'manual_stock_adjustment_in'    // Ajuste manual (entrada)
  | 'manual_stock_adjustment_out'   // Ajuste manual (salida)
  | 'transfer_in'                   // Ingreso por transferencia
  | 'transfer_out'                  // Salida por transferencia
  | 'transfer_not_received'         // Transferencia no recibida
  | 'import_initial_stock'          // Stock inicial por importación
  | 'import_stock_adjustment'       // Ajuste por importación

export interface InventoryMovement {
  id: number
  row_key: string
  affects_stock: boolean
  product_id: number
  product_name: string
  product_barcode?: string
  sucursal_id: number
  sucursal_name: string
  type: MovementType
  quantity: number | string | null
  /** Stock resultante después del movimiento */
  stock_after: number | null
  /** Razón o motivo (ajustes manuales) */
  reason?: string | null
  /** Referencia al documento origen (id de venta, compra, transferencia) */
  reference_id?: number | null
  reference_type?: string | null
  /** Nombre del proveedor cuando el registro proviene de una compra */
  supplier_name?: string | null
  purchase_reference_number?: string | null
  /** Batch/lote involucrado */
  batch_number?: string | null
  /** Usuario que generó el movimiento */
  user_name?: string | null
  user_email?: string | null
  origin_sucursal_name?: string | null
  destination_sucursal_name?: string | null
  created_at: string
}

// ─── Filtros ──────────────────────────────────────────────────────────────────

export interface InventoryMovementFilters extends ListParams {
  product_id?: number
  sucursal_id?: number
  type?: MovementType | ''
  /** Fecha inicio ISO YYYY-MM-DD */
  from?: string
  /** Fecha fin ISO YYYY-MM-DD */
  to?: string
  search?: string
}

// ─── Servicio ─────────────────────────────────────────────────────────────────

export const inventoryMovementsService = {
  async getMovements(
    params?: InventoryMovementFilters
  ): Promise<PaginatedResponse<InventoryMovement>> {
    const response = await http.get('/inventory-movements', { params })
    const d = response.data
    // Normaliza estructura anidada estilo Laravel
    if (d?.data?.data && Array.isArray(d.data.data)) return d.data
    if (d?.data && Array.isArray(d.data)) return d
    return d
  },
}
